import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import { CLINIC_DETAIL_PAGE_BREADCRUMB_CLICK } from '../../../../../../core/analytics/events';
import { BREADCRUMBS, getCustomization } from '../../../../util/customization';
import { safeGet } from '../../../../../../core/util/object';

const Root = styled.ol`
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  font-size: ${fontSize.small};
  list-style-type: none;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-padding-start: 0;
`;

const ListItem = styled.li`
  display: inline;
`;

const StyledLink = styled.a`
  text-decoration: none;
`;

const ItemName = styled.span`
  color: ${colors.lightText};
`;

const StyledSlash = styled.img`
  padding: 0 6px;
`;

const handleOnClick = (position, link) => {
  analyticsTrackEvent(CLINIC_DETAIL_PAGE_BREADCRUMB_CLICK, { position, link });
};

class Breadcrumb extends PureComponent {
  constructor(props) {
    super(props);
    const { sessionTrackingProperties } = props;
    const userAgent = safeGet(sessionTrackingProperties)('userAgent');
    this.breadcrumbsAreLinkable = getCustomization(BREADCRUMBS, { userAgent }).shouldBeLinkable;
  }
  render() {
    let index = 0;
    const { crumbs, className } = this.props;

    if (!this.breadcrumbsAreLinkable) {
      return (
        <Root className={className}>
          {crumbs.map((crumb, i) => (
            <Fragment key={crumb.name}>
              <ItemName>{crumb.name}</ItemName>
              {i !== crumbs.length - 1 && (
                <ListItem>
                  <StyledSlash src="/images/forward-slash.svg" alt="Forward Slash" />
                </ListItem>
              )}
            </Fragment>
          ))}
        </Root>
      );
    }

    return (
      <Root itemScope itemType="https://schema.org/BreadcrumbList" className={className}>
        {crumbs.map((crumb, i) => (
          <Fragment key={crumb.name}>
            {crumb.href ? (
              <ListItem itemScope itemProp="itemListElement" itemType="http://schema.org/ListItem">
                <StyledLink
                  itemProp="item"
                  href={crumb.href}
                  onClick={() => handleOnClick(index, crumb.href)}
                >
                  <ItemName itemProp="name">{crumb.name}</ItemName>
                  <meta itemProp="position" content={++index} />
                </StyledLink>
              </ListItem>
            ) : (
              <ItemName>{crumb.name}</ItemName>
            )}
            {i !== crumbs.length - 1 && (
              <ListItem>
                <StyledSlash src="/images/forward-slash.svg" alt="Forward Slash" />
              </ListItem>
            )}
          </Fragment>
        ))}
      </Root>
    );
  }
}

Breadcrumb.propTypes = {
  className: PropTypes.string,
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ).isRequired,
  sessionTrackingProperties: PropTypes.object,
};

export default Breadcrumb;
